import { useStore } from '@app/store/useStore.hook';
import { UserOutSchema } from './api/auth.schema';
import { AuthStatus } from './api/auth.type';
import { ECustomerGen, ETeamMemberRole } from '@app/swagger-types';

/**
 * @todo Update when adding new generations of users
 */
const oldGenList = [ECustomerGen.GEN1, ECustomerGen.GEN2, ECustomerGen.GEN3, ECustomerGen.GEN4];

/**
 * TODO refactor to fix type inference
 * currently, click on prop like `currentUser?.hasVerifiedEmail` does not navigate to UserOutSchema
 * NOTE: types explicitly declared for return type for easy click to inspect while inference not working
 */
export const useAuthorizedUser = (): {
  currentUser: UserOutSchema | null;
  authStatus: AuthStatus;
  isOldPlanUser: boolean;
  shouldShowOnboarding: boolean;
  is5GenUser: boolean;
  isOldGenUser: boolean;
} => {
  const currentUser = useStore.useCurrentUser();
  const authStatus = useStore.useAuthStatus();
  const isOldPlanUser =
    // unauthorized users should see new plan
    currentUser?.customerGen === ECustomerGen.GEN1 || false;
  const is5GenUser = currentUser?.customerGen === ECustomerGen.GEN5;
  const isOldGenUser = currentUser?.customerGen !== undefined && oldGenList.includes(currentUser.customerGen);

  const checkShouldShowOnboarding = (): boolean => {
    if (!currentUser) {
      return false;
    }
    const isSelfSignedUpCustomer =
      currentUser.teamMemberRole === ETeamMemberRole.OWNER || currentUser.teamMemberRole === ETeamMemberRole.NONE;
    if (!isSelfSignedUpCustomer) {
      // invited team members do not have onboarding
      return false;
    }
    return !currentUser.customerSegment;
  };
  const shouldShowOnboarding = checkShouldShowOnboarding();

  return { currentUser, authStatus, isOldPlanUser, shouldShowOnboarding, is5GenUser, isOldGenUser };
};
